import { render, staticRenderFns } from "./EditPartner.vue?vue&type=template&id=8a6725be&scoped=true"
import script from "./EditPartner.vue?vue&type=script&lang=ts"
export * from "./EditPartner.vue?vue&type=script&lang=ts"
import style0 from "./EditPartner.vue?vue&type=style&index=0&id=8a6725be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6725be",
  null
  
)

export default component.exports